import { IFaq } from '@pages/front/types/type'

export const GeneralFAQ: IFaq[] = [
  {
    question: 'What is Supchar?',
    answer:
      'Supchar is your one-stop digital platform for comprehensive healthcare services including medical appointments, lab tests, doctor consultations (in-person and video), and online medicine orders. We bring healthcare to your fingertips, making it easy and accessible for everyone in Nepal.',
  },
  {
    question: 'Where is Supchar located?',
    answer:
      'A: Supchar is proudly based in Kathmandu, Nepal, serving customers across the country with quality healthcare solutions.',
  },
  {
    question: 'What services does Supchar offer?',
    intro: 'At Supchar, we offer',
    lists: [
      'Medical and Doctor Appointments',
      'Lab Test Bookings',
      'Video Consultations with Licensed Doctors',
      'Online medicine orders',
      'General Healthcare Services and Support',
    ],
  },
  {
    question: 'How can I book a doctor appointment through Supchar?',
    answer:
      "A: Simply visit our website/app, choose your preferred doctor or specialty, select a time slot, and confirm your appointment. You'll receive a confirmation instantly.",
  },
  {
    question: 'Can I consult a doctor online via video call?',
    answer:
      'Yes! Supchar allows you to consult doctors via secure video calls, eliminating the need for travel while ensuring expert care from the comfort of your home.',
  },
  {
    question: 'How do I order medicines online?',
    answer:
      'A: Just upload your prescription or browse through our medicine catalog, add items to your cart, and proceed to checkout. We deliver your order directly to your doorstep',
  },
  {
    question: 'How can I contact Supchar for support?',
    intro: 'You can reach out to us by:',
    lists: ['Phone Call', 'Email: Contact@supchar.com'],
    outro: 'Our support team is always ready to help!',
  },
]
